import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import config from '../../../../config/config';

const CertificatesGrid = ({ section }) => {
  const theme = useTheme();
  
  if (!section || !section.certificates || !Array.isArray(section.certificates)) return null;
  const { certificates } = section;
  
  return (
    <Box sx={{ padding: theme.spacing(1, 0) }}>
      <Box 
        sx={{ 
          display: "flex", 
          flexWrap: "wrap", 
          gap: 2,
          justifyContent: "space-between"
        }}
      >
        {certificates.map((cert, index) => {
          const imageUrl =
          cert.formats?.large?.url || cert.formats?.medium?.url || cert.url;
         
          return (
            <Box
              key={index}
              sx={{
                width: "88px",
                height: "88px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: theme.palette.background.default,
                flexShrink: 0, // Nie pozwala elementom się kurczyć
              }}
            >
              <img
                src={`${config.CMS_BASE_URL}${imageUrl}`}
                alt={`Certificate ${index + 1}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  );
};

export default CertificatesGrid;

